import React, {Component} from 'react';
import styles from "./list.module.css";
import {FILE_URL} from "../../../util/constants";
import icDelete from "../../../img/delete.png";
import closeIcon from "../../../img/bt-close.png";
import defaultIcon from "../../../img/bee.png";
import MyImg from "../../myimg/myimg.jsx";
import back from "../../../img/ic_back.png";

const List = props => (

    <div className={styles.root}>
        <div className={styles.menubar}>
            <img className={styles["img-back"]} src={back} onClick={props.onRequestClose}/>
            <div className={styles["modal-title"]}>班级活动</div>
        </div>

        <div className={styles.container}>

            <div className={styles.test}>



            <div className={styles["list-wrapper"]}>
                {
                    props.activityList.length > 0 ? (
                            <React.Fragment>
                                {
                                    props.activityList.map((item, index, array) => {
                                        return (
                                            <div className={styles['list-item']} onClick={props.activityDetail.bind(null,item.code)}>

                                                <img
                                                    className={styles['item-img']}
                                                    src={FILE_URL + item.img}
                                                    onError={props.handleImageErrored.bind(this, index)}
                                                />
                                                <div>
                                                    <div className={styles["item-title"]}>{item.title}</div>

                                                    <div className={styles["text-num"]}>{item.taolun_num}讨论   {item.user_num}参与</div>
                                                </div>

                                            </div>
                                        );
                                    })
                                }
                            </React.Fragment>
                        )
                        : (<div className={styles['no-data']}>暂无记录</div>)
                }

            </div>
            </div>
        </div>
    </div>
)

export default List;
